import React from "react";
import { QuantityDiscount } from "~/ProductDetails/ProductDetailPageResult";
interface QuantityDiscountCardProps {
  quantityDiscount: QuantityDiscount;
}
const QuantityDiscountsTableHeader = ({
  quantityDiscount
}: QuantityDiscountCardProps) => {
  if (quantityDiscount.isLotDiscount) {
    return <div className="text-sm leading-none font-semibold">{`Lots of ${quantityDiscount.startQuantity}`}</div>;
  }
  let headerSuffix = "";
  if (quantityDiscount.startQuantity < (quantityDiscount.endQuantity ?? 0)) {
    headerSuffix = ` - ${quantityDiscount.endQuantity}`;
  } else if (quantityDiscount.startQuantity > (quantityDiscount.endQuantity ?? 0)) {
    headerSuffix = "+";
  }
  const labelText = `${quantityDiscount.startQuantity}${headerSuffix}`;
  return <span data-sentry-component="QuantityDiscountsTableHeader" data-sentry-source-file="QuantityDiscountsTableHeader.tsx">{labelText}</span>;
};
export default QuantityDiscountsTableHeader;